module.exports = __webpack_public_path__ + "static/media/unlock.a0a49271.svg";